import { useRef } from 'react';
import { Swiper as SwiperClass } from 'swiper/types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { usePopup } from "../context/PopupContext";
import { Link } from 'react-router-dom';
import { multiCenterData } from '../data/multiCenterData';
function toggleNavigation(swiper: SwiperClass) {
    const next = swiper?.navigation?.nextEl;
    const prev = swiper?.navigation?.prevEl;

    if (Number(swiper?.slides?.length) <= Number(swiper?.params?.slidesPerView)) {
        next.style.display = 'none';
        prev.style.display = 'none';
    } else {
        next.style.display = '';
        prev.style.display = '';
    }
}

export default function MultiCenterHolidays() {
    const swiperRef = useRef<SwiperClass | null>(null);
    const { openPopup } = usePopup();
    return (
        <section className="multi-center-holidays">
            <div className="container">
                <h3 className="section-subtitle">Signature Yacht Itineraries</h3>
                <h2 className="section-title">Tailored Voyages. Exceptional Moments. Entirely Yours.</h2>
                <h4 className="section-annotation">
                    Each charter is designed around your pace and preferences. Whether it’s secluded bays, vibrant coastal towns, or days at sea. With expert planning and personalised service, it’s yachting made unforgettable.
                </h4>

                <div className="cards">
                    <Swiper
                        className="multi-center-swiper"
                        modules={[Navigation]}
                        spaceBetween={16}
                        slidesPerView={1.4}
                        navigation={{
                            nextEl: '.multi-center-button-next',
                            prevEl: '.multi-center-button-prev',
                        }}
                        breakpoints={{
                            480: {
                                slidesPerView: 1.4,
                            },
                            768: {
                                slidesPerView: 2,
                            },
                            992: {
                                slidesPerView: 3,
                            },
                        }}
                        onAfterInit={(swiper: SwiperClass) => {
                            swiperRef.current = swiper;
                            toggleNavigation(swiper);
                        }}
                        onResize={(swiper: SwiperClass) => {
                            toggleNavigation(swiper);
                        }}
                    >
                        {multiCenterData.map((slide, idx) => (
                            <SwiperSlide key={idx}>
                                {slide.url ? (
                                    <Link to={slide.url} className="card">
                                        <div className="image-row">
                                            <img src={slide.image} alt={slide.alt} loading='lazy' />
                                        </div>
                                        <div className="card-content">
                                            <ul className="labels">
                                                <li>{slide.type}</li>
                                            </ul>
                                            <h3>{slide.title}</h3>
                                            <p className="info">{slide.description}</p>
                                        </div>
                                    </Link>
                                ) : (
                                    <div className="card" onClick={openPopup}>
                                        <div className="image-row">
                                            {/* <span>{slide.type}</span> */}
                                            <img src={slide.image} alt={slide.alt} loading='lazy' />
                                        </div>
                                        <div className="card-content">
                                            <ul className="labels">
                                                <li>{slide.type}</li>
                                            </ul>
                                            <h3>{slide.title}</h3>
                                            <p className="info">{slide.description}</p>
                                        </div>
                                    </div>
                                )}

                            </SwiperSlide>
                        ))}

                        <div className="swiper-button swiper-button-prev multi-center-button-prev">
                            <svg width="10" height="18" viewBox="0 0 10 18">
                                <path d="M1 1L9 9L1 17" stroke="currentColor" />
                            </svg>
                        </div>
                        <div className="swiper-button swiper-button-next multi-center-button-next">
                            <svg width="10" height="18" viewBox="0 0 10 18">
                                <path d="M1 1L9 9L1 17" stroke="currentColor" />
                            </svg>
                        </div>
                    </Swiper>
                </div>

                <button className="section-cta cta" onClick={openPopup} type="button">
                    Discover all signature itineraries
                </button>
            </div>
        </section>
    );
}